import React from 'react';
import { T } from '@tribeplatform/react-components/i18n';
import { Avatar } from '@tribeplatform/react-ui-kit/Avatar';
export const EmptyState = () => {
    return (React.createElement("div", { className: "grid grid-cols-1 gap-1" },
        [...Array(3)].map((_e, idx) => (React.createElement("div", { key: idx, className: "flex space-s-3 items-center p-2 opacity-50" },
            React.createElement(Avatar, { className: "h-10 w-10" }),
            React.createElement("div", { className: "h-5 bg-skeleton rounded-full flex flex-grow" })))),
        React.createElement("p", { className: "text-sm p-2" },
            React.createElement(T, { id: "Blocks.Leaderboard.WhenMembersAppear", defaultMessage: "{MEMBERS_CC} will appear here once they start engaging in the {COMMUNITY}." }))));
};
//# sourceMappingURL=EmptyState.js.map